import React, {
    createContext, useState, useMemo, 
   } from 'react';
   import PropTypes from 'prop-types';
   
   export const GlobalContext = createContext();
   
   const GlobalContextProvider = ({ children }) => {
    const [isFooterUpdate, setIsFooterUpdate] = useState(false);

  // Memoize the context value to avoid unnecessary re-renders
  const value = useMemo(() => ({
    isFooterUpdate, 
    setIsFooterUpdate,
  }), [isFooterUpdate]);

   
     return (
       <GlobalContext.Provider value={value}>
         {children}
       </GlobalContext.Provider>
     );
   };
   
   GlobalContextProvider.propTypes = {
     children: PropTypes.node.isRequired,
   };
   
   export default GlobalContextProvider;
